module.exports = __webpack_public_path__ + "static/img/icon_topsight.3faffb6c.svg";